import React from 'react';

import AddressMap from "pages/contact-us/components/address-map";
import ContactForm from "pages/contact-us/components/contact-form";
import AddressSlider from "pages/contact-us/components/address-slider";
import {useTranslation} from "react-i18next";

function ContactUsPage() {
    const {t} = useTranslation('contact-us')

    return (
        <div className='contact-page'>
        <div className="container ">
            <div className='row'>
            <div className="col-xl-6">
                <h1 className="title">{t('title')}</h1>
                <p className="desc">{t('info')}</p>
                <AddressSlider/>
                <AddressMap/>
            </div>

            <div className="col-xl-6">
                <ContactForm/>
            </div>
            </div>
        </div>
        </div>
    );
}

export default ContactUsPage;